export const dataKeys = fileData => {
  let data = null;

  if (fileData) {
    data = {
      cnes: fileData?.cnes,
      periodo: fileData?.periodo,
      partos_vaginais: fileData?.partos_vaginais,
      partos: fileData?.partos,
      int_cli: fileData?.int_cli,
      saidas_cli: fileData?.saidas_cli,
      int_cir: fileData?.int_cir,
      saidas_cir: fileData?.saidas_cir,
      pcr_ui: fileData?.pcr_ui,
      pd_ui: fileData?.pd_ui,
      obitos_np_cli: fileData?.obitos_np_cli,
      saidas_np_cli: fileData?.saidas_np_cli,
      obitos_nt_cli: fileData?.obitos_nt_cli,
      saidas_nt_cli: fileData?.saidas_nt_cli,
      obitos_ped_cli: fileData?.obitos_ped_cli,
      saidas_ped_cli: fileData?.saidas_ped_cli,
      obitos_adu_cli: fileData?.obitos_adu_cli,
      saidas_adu_cli: fileData?.saidas_adu_cli,
      obitos_ido_cli: fileData?.obitos_ido_cli,
      saidas_ido_cli: fileData?.saidas_ido_cli,
      obitos_neop_cir: fileData?.obitos_neop_cir,
      saidas_neop_cir: fileData?.saidas_neop_cir,
      obitos_neot_cir: fileData?.obitos_neot_cir,
      saidas_neot_cir: fileData?.saidas_neot_cir,
      obitos_ped_cir: fileData?.obitos_ped_cir,
      saidas_ped_cir: fileData?.saidas_ped_cir,
      obitos_adu_cir: fileData?.obitos_adu_cir,
      saidas_adu_cir: fileData?.saidas_adu_cir,
      obitos_ido_cir: fileData?.obitos_ido_cir,
      saidas_ido_cir: fileData?.saidas_ido_cir,
      pd_ped_cli: fileData?.pd_ped_cli,
      saidas_ped_cli_ti: fileData?.saidas_ped_cli_ti,
      pd_adu_cli: fileData?.pd_adu_cli,
      saidas_adu_cli_ti: fileData?.saidas_adu_cli_ti,
      pd_ido_cli: fileData?.pd_ido_cli,
      saidas_ido_cli_ti: fileData?.saidas_ido_cli_ti,
      pd_ped_cir: fileData?.pd_ped_cir,
      saidas_ped_cir_ti: fileData?.saidas_ped_cir_ti,
      pq_adu_cir: fileData?.pq_adu_cir,
      saidas_adu_cir_ti: fileData?.saidas_adu_cir_ti,
      pd_ido_cir: fileData?.pd_ido_cir,
      saidas_ido_cir_ti: fileData?.saidas_ido_cir_ti,
      tempo_emergencia: fileData?.tempo_emergencia,
      pac_emergencia: fileData?.pac_emergencia,
      esp_1aten_n2: fileData?.esp_1aten_n2,
      pacientes_n2: fileData?.pacientes_n2,
      esp_1aten_n3: fileData?.esp_1aten_n3,
      pacientes_n3: fileData?.pacientes_n3,
      cir_lim_prof60m: fileData?.cir_lim_prof60m,
      cir_lim: fileData?.cir_lim,
      isc_cir_lim: fileData?.isc_cir_lim,
      total_cir_lim: fileData?.total_cir_lim,
      ics_cvc_ui_neo: fileData?.ics_cvc_ui_neo,
      pac_ui_neo_cvcdia: fileData?.pac_ui_neo_cvcdia,
      ics_cvc_ui_ped: fileData?.ics_cvc_ui_ped,
      pac_ui_ped_cvcdia: fileData?.pac_ui_ped_cvcdia,
      ics_cvc_ui_adu: fileData?.ics_cvc_ui_adu,
      pac_ui_adu_cvcdia: fileData?.pac_ui_adu_cvcdia,
      ics_cvc_uti_neo: fileData?.ics_cvc_uti_neo,
      pac_uti_neo_cvcdia: fileData?.pac_uti_neo_cvcdia,
      ics_cvc_uti_ped: fileData?.ics_cvc_uti_ped,
      pac_uti_ped_cvcdia: fileData?.pac_uti_ped_cvcdia,
      ics_cvc_uti_adu: fileData?.ics_cvc_uti_adu,
      pac_uti_adu_cvcdia: fileData?.pac_uti_adu_cvcdia,
      itu_cvd_ui_neo: fileData?.itu_cvd_ui_neo,
      pac_ui_neo_cvddia: fileData?.pac_ui_neo_cvddia,
      itu_cvd_ui_ped: fileData?.itu_cvd_ui_ped,
      pac_ui_ped_cvddia: fileData?.pac_ui_ped_cvddia,
      itu_cvc_ui_adu: fileData?.itu_cvc_ui_adu,
      pac_ui_adu_cvddia: fileData?.pac_ui_adu_cvddia,
      itu_cvd_uti_neo: fileData?.itu_cvd_uti_neo,
      pac_uti_neo_cvddia: fileData?.pac_uti_neo_cvddia,
      itu_cvc_uti_ped: fileData?.itu_cvc_uti_ped,
      pac_uti_ped_cvddia: fileData?.pac_uti_ped_cvddia,
      itu_cvc_uti_adu: fileData?.itu_cvc_uti_adu,
      pac_uti_adu_cvddia: fileData?.pac_uti_adu_cvddia,
      prof_tev_ris_tro_cli: fileData?.prof_tev_ris_tro_cli,
      ris_tro_cli: fileData?.ris_tro_cli,
      prof_tev_ris_tro_cir_ort: fileData?.prof_tev_ris_tro_cir_ort,
      ris_tro_cir_ort: fileData?.ris_tro_cir_ort,
      prof_tev_ris_tro_cir_nao_ort: fileData?.prof_tev_ris_tro_cir_nao_ort,
      ris_tro_cir_nao_ort: fileData?.ris_tro_cir_nao_ort,
      quedas: fileData?.quedas,
      pd: fileData?.pd,
      eve_sentinela: fileData?.eve_sentinela,
      total_internacoes: fileData?.total_internacoes,
    };
  }

  return data;
};
